import Hero from "../../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import StampDutyCalculator from "../../calculators/StampDutyCalculator";
import SEO from "../../designSystem/SEO";

const StampDutyPage = () => {
  return (
    <div>
      <SEO
        title="Stamp Duty Calculator"
        description="Estimate stamp duty and property tax costs for homes in England, Northern Ireland, Scotland and Wales with AK Mortgages."
        path="/calculators/stamp-duty"
      />
      <Hero
        title="Estimate Your Purchase Costs"
        subtitle="Stamp Duty Calculator"
        showContactButton={false}
        // backgroundImage={CalculatorsImag1}
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            Stamp Duty Land Tax (SDLT) is an important cost to consider when
            buying a property. Our stamp duty calculator helps you estimate the
            property tax you may need to pay when buying a home in the UK.
          </div>
        </div>
      </Hero>
      <StampDutyCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default StampDutyPage;
